import { Alert, Select, Switch } from 'antd';
import { LabeledField } from '~components/form-fields/labeled-field';
import { Section } from '~components/form-fields/section';
import { FeaturedForm } from '~stores/featured';
import { isLegacyFeaturedType } from '~utils/const';
import { ApplicationTargetEnum } from '~types/app-selection';
import style from './style.module.scss';

interface ConfigSectionProps {
    values: FeaturedForm;
    setFieldValue: (field: string, value: unknown) => void;
}

export const ConfigSection = ({
    values,
    setFieldValue,
}: ConfigSectionProps) => {
    const isLegacy = isLegacyFeaturedType(values.type);

    return (
        <Section title="Config">
            {isLegacy && (
                <Alert
                    type="error"
                    showIcon
                    message="This featured is using a legacy type that is no longer supported. It cannot be saved."
                    style={{ marginBottom: 16 }}
                />
            )}
            <div className={style.config_fields_container}>
                <LabeledField label="Is Active">
                    <div className={style.switch_wrapper}>
                        <Switch
                            checked={values.isActive}
                            onChange={(checked) =>
                                setFieldValue('isActive', checked)
                            }
                            disabled={isLegacy}
                        />
                    </div>
                </LabeledField>
                <LabeledField label="Redirect to...">
                    <div className={style.select_wrapper}>
                        <Select
                            onChange={(v) => setFieldValue('type', v)}
                            value={values.type}
                            disabled={isLegacy}
                        >
                            <Select.Option value="promotion">
                                Promotion
                            </Select.Option>
                            <Select.Option value="games">Games</Select.Option>
                            <Select.Option value="external_url">
                                External url
                            </Select.Option>
                        </Select>
                    </div>
                </LabeledField>
                {values.type === 'external_url' && (
                    <LabeledField label="Region">
                        <div className={style.select_wrapper}>
                            <Select
                                placeholder="Select a region"
                                onChange={(v) =>
                                    setFieldValue('appTarget', v ?? null)
                                }
                                value={values.appTarget ?? undefined}
                            >
                                <Select.Option value={ApplicationTargetEnum.QC}>
                                    Quebec only
                                </Select.Option>
                                <Select.Option value={ApplicationTargetEnum.CA}>
                                    Canada (excluding Quebec)
                                </Select.Option>
                            </Select>
                        </div>
                    </LabeledField>
                )}
            </div>
        </Section>
    );
};
